var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.66669H7.33329M9.33329 11.3334H3.33329M9.33329 11.3334C9.33329 12.4379 10.2287 13.3334 11.3333 13.3334C12.4379 13.3334 13.3333 12.4379 13.3333 11.3334C13.3333 10.2288 12.4379 9.33335 11.3333 9.33335C10.2287 9.33335 9.33329 10.2288 9.33329 11.3334ZM6.66663 4.66669C6.66663 5.77126 5.7712 6.66669 4.66663 6.66669C3.56206 6.66669 2.66663 5.77126 2.66663 4.66669C2.66663 3.56212 3.56206 2.66669 4.66663 2.66669C5.7712 2.66669 6.66663 3.56212 6.66663 4.66669Z",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarConfig);
export default __webpack_public_path__ + "static/media/sidebar-config.0c1a996614cbdea662907986f6a6f725.svg";
export { ForwardRef as ReactComponent };